var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(_vm.isInitializing)?[_c('v-container',{staticClass:"primary fill-height",attrs:{"fluid":""}},[_c('v-row',{attrs:{"justify":"center"}},[_c('v-col',{attrs:{"cols":"auto"}},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"white"}})],1)],1)],1)]:[_c('UISystemBar'),_c('v-main',[_c('router-view')],1),_c('UISnackbar')]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }